module.exports = __webpack_public_path__ + "assets/img/5_1264_big.79b28474.jpg";